import http from "src/shared/http";
import projectOptions from "src/shared/project-options";

export function fetchEvents() {
  const { eventId, baseUrl } = projectOptions.default.network;
  return http(baseUrl + "/public/events/" + eventId + "/");
}

export function fetchReplayHighlights() {
  const { eventId, baseUrl } = projectOptions.default.network;
  return http(`${baseUrl}/public/events/${eventId}/timelines/`);
}
